var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signOn"},[_c('div',{staticClass:"signOn_box"},[_c('img',{attrs:{"src":"https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/srm/img/pixiaote_head.gif","alt":"","srcset":""}}),_vm._v("\n    宁东工业超市平台登录中,请稍后...\n  ")])])
}]

export { render, staticRenderFns }